import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateTrack } from '../action-creators';
import AppState from '../../state';
import { FinishAssetUpload } from '../../assets/action-creators';
import { FINISH_ASSET_UPLOAD } from '../../assets/actions';

/**
 *
 * This effect creates a Track after a successful Asset upload *WHEN THE RELEASE EXISTS*
 *
 */

export const createTracksAfterAssetEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, FinishAssetUpload>(FINISH_ASSET_UPLOAD),
    withLatestFrom(state$),
    filter(([action, state]) => !!state.release.release?.id && action.assetId in state.tracks.tracks),
    map(([action, state]) => {
      return new CreateTrack(action.assetId, state.release.release?.id as string);
    })
  );